/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector, useDispatch } from 'react-redux';

import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Button, Grid2, TextField, Typography } from '@mui/material';

import { postForm, deleteLastPostForm } from 'js/actions/formsAction';
import { showCards } from 'js/actions/cardAction';

import { makeStyles } from '@mui/styles';
import styles from './styles';
import { useIntl } from 'react-intl';
const useStyles = makeStyles(styles);

function useOnMount(handler) {
  return React.useEffect(handler, []);
}

const defaultSelectValues = {
  concentratorPhase: null,
  cardPhaseA: null,
  relationPhaseA: null,
};

function MonoPhasicForm(props) {
  const intl = useIntl();
  const { setValue, getValues, register, handleSubmit } = useForm({
    defaultSelectValues,
  });
  const dispatch = useDispatch();
  let cards = useSelector((state) => state.cards.cards);
  const comunicationStepForm = useSelector((state) => state.forms.data[1]);
  const { concentratorPhase } = comunicationStepForm;

  const [voltage, setVoltage] = useState('220');

  const onSubmit = (values) => {
    dispatch(postForm(values));
    props.nextStep();
    //console.log('DATA: ', values);
  };

  const handleCurrentRelation = (event) => {
    setValue('relationCurrent', event.target.value);
  };

  const handleVoltageRelation = (event) => {
    setValue('relationVoltage', event.target.value);
  };

  const handleBack = () => {
    dispatch(deleteLastPostForm());
    props.prevStep();
  };

  const handleVoltage = (voltage) => {
    setVoltage(voltage.target.value);
  };

  const handleCardPhaseA = (cardPhaseA) => {
    setValue('cardPhaseA', cardPhaseA.target.value);
    let modbusSelected = cards.find(
      (card) => card.id === cardPhaseA.target.value
    );
    setValue('modbus', modbusSelected.modbus);
  };

  useEffect(() => {
    dispatch(showCards(concentratorPhase));
  }, []);

  useOnMount(() => {
    register('concentratorPhase', 'text');

    register('cardPhaseA', 'text');

    register('modbus', 'text');

    register('relationCurrent', 'text');

    register('relationVoltage', 'text');
  });

  const values = getValues();

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Typography sx={{ marginBottom: '2rem' }} variant="h4">
          {intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.configuration.phaseConftitle',
          })}
        </Typography>
        <Grid2 container={true} spacing={3}>
          <Grid2 size={{ lg: 2.4, md: 6, xs: 12 }}>
            <FormControl className={classes.textField} variant="outlined">
              <InputLabel
                id="demo-simple-select-outlined-label"
                inputRef={useOnMount}
              >
                {intl.formatMessage({
                  id: 'app.chargesCards.addCharge.stepper.configuration.cardLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                onChange={handleCardPhaseA}
                value={values.cardPhaseA}
                label={intl.formatMessage({
                  id: 'app.chargesCards.addCharge.stepper.configuration.cardLbl',
                })}
                //labelWidth={labelWidth}
              >
                {cards.map((card) => (
                  <MenuItem value={card.id} key={card.id}>
                    {card.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 2.4, md: 6, xs: 12 }}>
            <TextField
              fullWidth
              disabled
              label="Modbus"
              value={values.modbus || ''}
            />
          </Grid2>
          <Grid2 size={{ lg: 2.4, md: 6, xs: 12 }}>
            <FormControl className={classes.textField} variant="outlined">
              <InputLabel
                id="demo-simple-select-outlined-label"
                inputRef={useOnMount}
              >
                Relación Corriente
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                label="Relación Corriente"
                onChange={handleCurrentRelation}
                value={values.relationCurrent}
                //labelWidth={labelWidth}
              >
                <MenuItem value="50:1">50:1</MenuItem>
                <MenuItem value="100:1">100:1</MenuItem>
                <MenuItem value="130:1">130:1</MenuItem>
                <MenuItem value="200:1">200:1</MenuItem>
                <MenuItem value="500:1">500:1</MenuItem>
                <MenuItem value="1000:1">1000:1</MenuItem>
                <MenuItem value="25:5">25:5</MenuItem>
                <MenuItem value="50:5">50:5</MenuItem>
                <MenuItem value="75:5">75:5</MenuItem>
                <MenuItem value="100:5">100:5</MenuItem>
                <MenuItem value="150:1">150:1</MenuItem>
                <MenuItem value="150:5">150:5</MenuItem>
                <MenuItem value="200:5">200:5</MenuItem>
                <MenuItem value="250:5">250:5</MenuItem>
                <MenuItem value="300:1">300:1</MenuItem>
                <MenuItem value="300:5">300:5</MenuItem>
                <MenuItem value="400:5">400:5</MenuItem>
                <MenuItem value="500:5">500:5</MenuItem>
                <MenuItem value="600:5">600:5</MenuItem>
                <MenuItem value="800:5">800:5</MenuItem>
                <MenuItem value="1000:5">1000:5</MenuItem>
                <MenuItem value="1500:5">1500:5</MenuItem>
                <MenuItem value="2000:1">2000:1</MenuItem>
                <MenuItem value="2000:5">2000:5</MenuItem>
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={{ lg: 2.4, md: 6, xs: 12 }}>
            <FormControl className={classes.textField} variant="outlined">
              <InputLabel
                id="demo-simple-select-outlined-label"
                inputRef={useOnMount}
              >
                Relacion Voltaje
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                labelId="demo-simple-select-outlined-label"
                label="Relacion Voltaje"
                onChange={handleVoltageRelation}
                value={values.relationVoltage}
                //labelWidth={labelWidth}
              >
                <MenuItem value="50:1">50:1</MenuItem>
                <MenuItem value="100:1">100:1</MenuItem>
                <MenuItem value="130:1">130:1</MenuItem>
                <MenuItem value="200:1">200:1</MenuItem>
                <MenuItem value="500:1">500:1</MenuItem>
                <MenuItem value="1000:1">1000:1</MenuItem>
                <MenuItem value="25:5">25:5</MenuItem>
                <MenuItem value="50:5">50:5</MenuItem>
                <MenuItem value="75:5">75:5</MenuItem>
                <MenuItem value="100:5">100:5</MenuItem>
                <MenuItem value="150:1">150:1</MenuItem>
                <MenuItem value="150:5">150:5</MenuItem>
                <MenuItem value="200:5">200:5</MenuItem>
                <MenuItem value="250:5">250:5</MenuItem>
                <MenuItem value="300:1">300:1</MenuItem>
                <MenuItem value="300:5">300:5</MenuItem>
                <MenuItem value="400:5">400:5</MenuItem>
                <MenuItem value="500:5">500:5</MenuItem>
                <MenuItem value="600:5">600:5</MenuItem>
                <MenuItem value="800:5">800:5</MenuItem>
                <MenuItem value="1000:5">1000:5</MenuItem>
                <MenuItem value="1500:5">1500:5</MenuItem>
                <MenuItem value="2000:1">2000:1</MenuItem>
                <MenuItem value="2000:5">2000:5</MenuItem>
              </Select>
            </FormControl>
          </Grid2>

          <Grid2 size={{ lg: 2.4, md: 12, xs: 12 }}>
            <FormControl className={classes.textField} variant="outlined">
              <InputLabel>ADE</InputLabel>
              <Select defaultValue={1} {...register('ajustPhaseA')} label="ADE">
                <MenuItem value={1}>1</MenuItem>
                <MenuItem value={2}>2</MenuItem>
              </Select>
            </FormControl>
          </Grid2>
          <Grid2 size={12}>
            <Typography style={{ marginBottom: '25px' }} variant="h4">
              {intl.formatMessage({
                id: 'app.chargesCards.addCharge.stepper.configuration.predefVolt',
              })}{' '}
            </Typography>
            <FormControl className={classes.textField} variant="outlined">
              <InputLabel id="demo-simple-select-outlined-label">
                {intl.formatMessage({
                  id: 'app.chargesCards.addCharge.stepper.configuration.voltageLbl',
                })}
              </InputLabel>
              <Select
                id="demo-simple-select-outlined"
                {...register('voltage')}
                labelId="demo-simple-select-outlined-label"
                name="voltage"
                label={intl.formatMessage({
                  id: 'app.chargesCards.addCharge.stepper.configuration.voltageLbl',
                })}
                onChange={handleVoltage}
                value={voltage}
                //labelWidth={labelWidth}
              >
                <MenuItem value="110">110</MenuItem>
                <MenuItem value="127">127</MenuItem>
                <MenuItem value="220">220</MenuItem>
                <MenuItem value="230">230</MenuItem>
                <MenuItem value="277">277</MenuItem>
                <MenuItem value="280">280</MenuItem>
                <MenuItem value="360">360</MenuItem>
                <MenuItem value="375">375</MenuItem>
                <MenuItem value="440">440</MenuItem>
                <MenuItem value="480">480</MenuItem>
              </Select>
            </FormControl>
          </Grid2>

          <Grid2 size={12}>
            <Typography
              style={{ marginBottom: '7px', marginTop: '20px' }}
              variant="h4"
            >
              {intl.formatMessage({
                id: 'app.chargesCards.addCharge.stepper.configuration.predefFP',
              })}{' '}
            </Typography>

            <TextField
              className={classes.textField}
              defaultValue={0.95}
              helperText={intl.formatMessage({
                id: 'app.chargesCards.addCharge.stepper.configuration.fpMsg',
              })}
              {...register('fp')}
              label={intl.formatMessage({
                id: 'app.chargesCards.addCharge.stepper.configuration.fpLbl',
              })}
              margin="normal"
              name="fp"
              style={{ marginBottom: '30px', marginTop: '20px' }}
              variant="outlined"
            />
          </Grid2>
        </Grid2>

        <Button
          color="secondary"
          size="large"
          sx={{ marginTop: '10px' }}
          type="submit"
          variant="contained"
          fullWidth={true}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.configuration.saveAndContinueBtn',
          })}
        </Button>
        <Button
          className={classes.backButton}
          onClick={handleBack}
          size="large"
          sx={{ margin: '1rem 0 1.5rem' }}
          variant="outlined"
          color="secondary"
          fullWidth={true}
        >
          {intl.formatMessage({
            id: 'app.chargesCards.addCharge.stepper.configuration.returnBtn',
          })}
        </Button>
      </form>
    </div>
  );
}

export default MonoPhasicForm;
